import React from 'react'
import PropTypes from 'prop-types'

const IntegrationIcon = (props) => {
  const { color = '#404040', classes = 'w-20' } = props
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M20 5V4C20 3.45 19.55 3 19 3H17C16.45 3 16 3.45 16 4V5C15.45 5 15 5.45 15 6V9C15 9.55 15.45 10 16 10H17V16.91C17 17.95 16.24 18.89 15.21 18.99C14.01 19.11 13 18.17 13 17V7.14C13 5.01 11.39 3.15 9.26 3.01C6.93 2.86 5 4.7 5 7V14H4C3.45 14 3 14.45 3 15V18C3 18.55 3.45 19 4 19V20C4 20.55 4.45 21 5 21H7C7.55 21 8 20.55 8 20V19C8.55 19 9 18.55 9 18V15C9 14.45 8.55 14 8 14H7V7.09C7 6.05 7.76 5.11 8.79 5.01C9.99 4.89 11 5.83 11 7V16.86C11 18.99 12.61 20.85 14.74 20.99C17.07 21.14 19 19.3 19 17V10H20C20.55 10 21 9.55 21 9V6C21 5.45 20.55 5 20 5Z"
        fill={color}
      />
    </svg>
  )
}

IntegrationIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(IntegrationIcon)
